import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { NotificationIcon } from '@src/components/Icons/NotificationIcon';
import { TimeAgo } from '@src/components/TimeAgo';
import { useApprovals } from '@src/hooks/useApprovals';
import { useAuth } from '@src/hooks/useAuth';
import { sortBy } from 'lodash';
import { ArrowRightIcon, DotIcon } from 'lucide-react';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { Link } from 'react-router-dom';
import styles from './ApprovalTasksNotification.module.scss';
export const ApprovalTasksNotification = () => {
    const { t } = useLocale();
    const { currentUser, isManager } = useAuth();
    const { approvals, total } = useApprovals({
        clientId: isManager ? currentUser?.clientId : undefined,
        onlyPending: true,
        useFilter: false, // Don't apply filter state for homepage notification
    });
    const oldest = sortBy(approvals, 'submittedAt')[0];
    if (!isManager || total === 0)
        return null;
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: 'flex gap-2', children: [_jsx(NotificationIcon, { fontSize: 'small' }), _jsxs("div", { className: 'flex flex-col gap-1', children: [_jsx(Typography, { variant: 'label1', children: t('Action required') }), _jsxs("div", { className: styles.subTitle, children: [oldest?.submittedAt && (_jsx(Typography, { variant: 'label2', children: _jsx(TimeAgo, { date: oldest?.submittedAt }) })), _jsx(DotIcon, { size: 40 }), _jsx(Typography, { variant: 'label2', children: t('Approval') })] }), _jsx("div", { className: 'mt-2', children: _jsx(Typography, { variant: 'body1', children: t('You have {total} requests ready for manager approval', {
                                    values: { total },
                                }) }) }), _jsx("div", { className: 'mt-2', children: _jsx(TrackableButton, { enText: 'Review', tag: 'approval_notification', Component: Link, to: '/tasks', appearance: 'primary', children: _jsxs("span", { className: 'flex items-center gap-1', children: [t('Review'), " ", _jsx(ArrowRightIcon, { size: 20 })] }) }) })] })] }) }));
};
